import useSWR from 'swr';
import { apiURL } from '@/constant/apiURL';
import { getNestedDataFetcher, postDataFetcher } from '@/utils/apis';

export type FileChatRequest = {
  message: string;
  threadId?: string;
  conversationId?: string;
};

export type FileChatAcceptedData = {
  threadId: string;
  topic: string;
  aiPipelineId: string;
  conversationId?: string | null;
};

export type FileChatResponse = {
  data: FileChatAcceptedData;
};

export const useFileSuggestion = (fileUuid: string) => {
  return useSWR<{ suggestions: string[] }>(
    fileUuid ? apiURL.FILE_SUGGESTION(fileUuid) : null,
    getNestedDataFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
};

export const postFileChat = (fileUuid: string, payload: FileChatRequest) =>
  postDataFetcher<FileChatRequest, FileChatResponse>(
    apiURL.FILE_CHAT(fileUuid),
    payload,
  );
